import React from 'react';
import './InfoCard.css';

const InfoCard = ({ icon: Icon, title, description,variant = 'default',id  }) => {
   const isBlueVariant = variant === 'blue';
  return (
    <div className={`info-card ${isBlueVariant ? 'blue' : ''}`}>

      <div className={`icon-wrapper ${isBlueVariant ? 'blue-bg' : ''}`}>
        <Icon className={`icon ${isBlueVariant ? 'white-icon' : ''}`} />
      </div>
      <h3 className="card-title">{title}</h3>
      <div className="card-desc">{description}</div>
    </div>
  );
};

export default InfoCard;
